// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/common.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/common.proto.
 */
export const file_agentplatform_httpv2_common: GenFile = /*@__PURE__*/
  fileDesc("CiFhZ2VudHBsYXRmb3JtL2h0dHB2Mi9jb21tb24ucHJvdG8SJ2luZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLmh0dHB2MiKbBQoLTGlzdFJlcXVlc3QSFQoEcGFnZRgBIAEoBUIHukgEGgIoABIoCglwYWdlX3NpemUYAiABKAVCCrpIBxoFGOgHKABSCXBhZ2Vfc2l6ZRJQCgZmaWx0ZXIYAyADKAsyQC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5odHRwdjIuTGlzdFJlcXVlc3QuRmlsdGVyRW50cnkSTgoFZnV6enkYBCADKAsyPy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5odHRwdjIuTGlzdFJlcXVlc3QuRnV6enlFbnRyeRIaCghvcmRlcl9ieRgFIAMoCVIIb3JkZXJfYnkSSAoCaW4YBiADKAsyPC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5odHRwdjIuTGlzdFJlcXVlc3QuSW5FbnRyeRJXCgZub3RfaW4YByADKAsyPy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS5odHRwdjIuTGlzdFJlcXVlc3QuTm90SW5FbnRyeVIGbm90X2luEhgKB2lzX251bGwYCCADKAlSB2lzX251bGwSGgoIbm90X251bGwYCSADKAlSCG5vdF9udWxsGi0KC0ZpbHRlckVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEaLAoKRnV6enlFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBGikKB0luRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ARosCgpOb3RJbkVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFCUVpPZ2l0bGFiLmluZmluaS1haS5jb20vbWl6YXIvaW5maW5pYWktYWdlbnRpYy1pbmZyYS9jb21tb24vZ3JwY2FwaXMvaHR0cHYyO2h0dHB2MmIGcHJvdG8z", [file_buf_validate_validate]);

/**
 * ListRequest 是 httpv2 各域列表 RPC 共用的请求体。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRequest
 */
export type ListRequest = Message<"infinigence.infini.agentplatform.httpv2.ListRequest"> & {
  /**
   * 分页页码（从 1 开始；0 / 缺省 = 1）
   * @gotags: json:"page,omitempty"
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页大小（最大 1000；0 / 缺省 = 10）
   * @gotags: json:"page_size,omitempty"
   *
   * @generated from field: int32 page_size = 2 [json_name = "page_size"];
   */
  pageSize: number;

  /**
   * 精确过滤，如 {"name":"alice","status":"active"}
   * @gotags: json:"filter,omitempty"
   *
   * @generated from field: map<string, string> filter = 3;
   */
  filter: { [key: string]: string };

  /**
   * 模糊搜索，如 {"name":"demo"}
   * @gotags: json:"fuzzy,omitempty"
   *
   * @generated from field: map<string, string> fuzzy = 4;
   */
  fuzzy: { [key: string]: string };

  /**
   * 排序，如 ["created_at-","name+"]（后缀 + 升序 / - 降序）
   * @gotags: json:"order_by,omitempty"
   *
   * @generated from field: repeated string order_by = 5 [json_name = "order_by"];
   */
  orderBy: string[];

  /**
   * IN 过滤，如 {"tenant_id":"t1|t2"}
   * @gotags: json:"in,omitempty"
   *
   * @generated from field: map<string, string> in = 6;
   */
  in: { [key: string]: string };

  /**
   * NOT IN 过滤，如 {"tenant_id":"t1|t2"}
   * @gotags: json:"not_in,omitempty"
   *
   * @generated from field: map<string, string> not_in = 7 [json_name = "not_in"];
   */
  notIn: { [key: string]: string };

  /**
   * IS NULL 过滤，如 ["deleted_at"]
   * @gotags: json:"is_null,omitempty"
   *
   * @generated from field: repeated string is_null = 8 [json_name = "is_null"];
   */
  isNull: string[];

  /**
   * IS NOT NULL 过滤，如 ["updated_at"]
   * @gotags: json:"not_null,omitempty"
   *
   * @generated from field: repeated string not_null = 9 [json_name = "not_null"];
   */
  notNull: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_common, 0);

